import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import toast from "react-hot-toast";

const SubscribeEmail = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post("https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/contact/subscribe/", {
        email: email.trim(),
      });

      const message = res.data.message || "Subscribed successfully!";
      if (res.status === 201) {
        toast.success(message);
      } else {
        toast(message, {
          icon: "ℹ️",
          style: { background: "#1976d2", color: "#fff" },
        });
      }

      setEmail("");
    } catch (error) {
      const err =
        error.response?.data?.error ||
        error.response?.data?.detail ||
        "Subscription failed. Please try again later.";
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscribe-form">
      <form className="mc-form" onSubmit={submit}>
        <div>
          <input
            id="mc-form-email"
            className="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address..."
            required
          />
        </div>
        <div className="clear">
          <button className="button" type="submit" disabled={loading}>
            {loading ? "SENDING..." : "SUBSCRIBE"}
          </button>
        </div>
      </form>
    </div>
  );
};

SubscribeEmail.propTypes = {};

export default SubscribeEmail;
